/**
 * Type guard function that checks if a value is a number.
 * Returns true if the value is a number, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a number, false otherwise
 *
 * @example
 * ```ts
 * import { NumberQ } from "@pdfking/structs"
 *
 * const num = 42;
 * const str = "42";
 *
 * if (NumberQ(num)) {
 *   console.log(num.toFixed(2)); // "42.00" (type narrowed to number)
 * }
 *
 * if (NumberQ(str)) {
 *   // This block won't execute
 * }
 *
 * // Use in filtering
 * const mixed = [1, "two", 3, "four"];
 * const numbers = mixed.filter(NumberQ); // [1, 3]
 * ```
 */
export const NumberQ = <T>(value: T): value is number & T => typeof value === "number"
